exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header .raul-header-product {\n  margin: 0;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n  margin: -2px 0 -3px; }\n\nheader .raul-header-product {\n  margin-top: 9px !important; }\n\nheader .raul-header-user-handle {\n  margin-top: 18px !important; }\n\n.list-group-item {\n  border-radius: 0; }\n\n.raul-header-user-angle {\n  margin: 18px 20px 20px 0;\n  padding-left: 5px; }\n\n.help-guilde {\n  font-size: 20px;\n  margin: 18px 15px;\n  color: #fff;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /azp/_work/1/s/src/app/navbar/navbar.component.scss
// module id = ../../../../../src/app/navbar/navbar.component.scss
// module chunks = main